module.exports = __webpack_public_path__ + "static/assets/35bb37b07197649f523c8866b20be42b.png";